import {
    Container,
    Flex,
    Input,
    Button,
    FormControl,
    FormLabel,
    useBreakpointValue,
    Box,
    Center,
    Text,
    FormErrorMessage,
    useToast
} from '@chakra-ui/react';
import { Formik, Field, Form } from 'formik';
import { HttpStatusCode } from 'axios';
import { useNavigate } from 'react-router-dom';

import ForgotPasswordBG from '@/assets/png/NewLoginBG.png';
import PertaminaLogoLogin from '@/assets/PertaminaLogoLogin';
import { COLORS, DURATION_TOAST } from '@/common/constants';
import Footer from '@/components/Layouts/Footer';
import { resetPasswordSchema } from '@/schemas/resetPasswordSchema';
import { resetPassword } from '@/services/inspectionUserService';

const ResetPassword = () => {
    const isWideScreen = useBreakpointValue({ base: false, md: true });
    const toast = useToast();
    const navigate = useNavigate();

    let email = '';
    let token = '';

    const url = new URL(window.location.href);
    const params = url.search.slice(1).split('&');

    params.forEach(param => {
        const [key, value] = param.split(':');
        if (key === 'e') {
            email = decodeURIComponent(value);
        } else if (key === 't') {
            token = decodeURIComponent(value);
        }
    });

    const validateURLParams = () => {
        let listError = [];
        let errorMessage = '';

        if (!email) {
            listError.push('email');
        }

        if (!token) {
            listError.push('token');
        }

        errorMessage += listError.join(', ');
        errorMessage += 'is empty';

        return {
            isValid: listError.length === 0,
            errorMessage: errorMessage === 'is empty' ? '' : errorMessage
        };
    }

    const handleSubmit = async (values: any) => {
        const dataValidation = validateURLParams();
        if (!dataValidation.isValid) {
            toast({
                title: 'Unable to find the email/token',
                description: dataValidation.errorMessage,
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });

            return;
        }

        const data = { ...values, email, token };
        const response = await resetPassword(data) as any;
        if (response.status === HttpStatusCode.Ok) {
            toast({
                title: 'Password updated',
                description: "We've updated your password.",
                status: 'success',
                duration: DURATION_TOAST,
                isClosable: true,
            });

            setTimeout(() => {
                navigate('/');
            }, 2000)
        } else {
            toast({
                title: 'Password failed to update.',
                description: "We unabled to update the password for you.",
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }
    }

    return (
        <Container maxW="100%" minH="80vh" p={0}>
            <Flex
                minH="calc(100vh - 70px)"
                direction={isWideScreen ? 'row' : 'column'}
                align="center"
                justify="flex-start"
                bgImage={`url(${ForgotPasswordBG})`}
                bgSize="cover"
                bgPosition="center"
                position="relative"
                overflow="hidden"
            >
                <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    // bg="rgba(248, 250, 252, 0.9)"
                    p={8}
                    w={isWideScreen ? 500 : '100%'}
                    h={isWideScreen ? '90vh' : 'auto'}
                    borderRadius="md"
                    // boxShadow="md"
                    zIndex="1"
                    alignSelf="flex-start"
                >
                    <Box p={10} borderRadius={10} bg="white" boxShadow='md' style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                        <Center>
                            <PertaminaLogoLogin />
                        </Center>
                        <Text fontSize='30px' mt={6} mb={6} fontWeight='semibold'>Reset Password?</Text>
                        <Formik
                            initialValues={{ newPassword: '', confirmPassword: '' }}
                            validationSchema={resetPasswordSchema}
                            onSubmit={(values) => {
                                const trimmedValues = {
                                    newPassword: values.newPassword.trim(),
                                    confirmPassword: values.confirmPassword.trim(),
                                };
                                handleSubmit(trimmedValues);
                            }}
                        >
                            {(props) => (
                                <Form style={{ marginTop: 0 }}>
                                    <Field name='newPassword'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.newPassword && form.touched.newPassword} style={{ marginBottom: 15 }}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <FormLabel style={{ marginTop: '5px' }}>Password</FormLabel>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input {...field} type='password' placeholder='Enter your new password' style={{ flex: 1, backgroundColor: 'white' }} />
                                                    </div>
                                                </div>
                                                <FormErrorMessage>{form.errors.newPassword}</FormErrorMessage>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='confirmPassword'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.confirmPassword && form.touched.confirmPassword} style={{ marginBottom: 15 }}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <FormLabel style={{ marginTop: '5px' }}>Confirm Password</FormLabel>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input {...field} type='password' placeholder='Re-enter your new password' style={{ flex: 1, backgroundColor: 'white' }} />
                                                    </div>
                                                </div>
                                                <FormErrorMessage>{form.errors.confirmPassword}</FormErrorMessage>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button
                                            mt={4}
                                            bgColor={COLORS.BUTTON.BACKGROUND}
                                            color={COLORS.BUTTON.FOREGROUND}
                                            isLoading={props.isSubmitting}
                                            type='submit'
                                            width='100%'
                                        >
                                            RESET PASSWORD
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Flex>
            </Flex>
            <Footer />
        </Container >
    );
}

export default ResetPassword;
